import { connect } from 'react-redux';

import SkinWrapper from '~/Components/Layout/SkinWrapper/SkinWrapper';

import { increment, decrement, heartbeat } from '~/Redux/Modules/DateRange';
import { setLoaded, setSrc } from '~/Redux/Modules/SkinWrapper';

const mapStateToProps = ({ UserOptions, DateRange, SkinWrapper }) => {
  return {
    currentSkin: UserOptions.data.skin,
    start: DateRange.start,
    end: DateRange.end,
    currentType: DateRange.currentType,
    loaded: SkinWrapper.loaded,
    imageWidth: SkinWrapper.imageWidth,
    src: SkinWrapper.src,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    increment: (currentType, start) => dispatch(increment(currentType, start.clone())),
    decrement: (currentType, start) => dispatch(decrement(currentType, start.clone())),
    setLoaded: (loaded, imageWidth) => dispatch(setLoaded(loaded, imageWidth)),
    setSrc: src => dispatch(setSrc(src)),
    heartbeatFn: start => dispatch(heartbeat(start.clone())),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SkinWrapper);
